module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "accordion-item weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.makeSwitch($event)
      }
    }
  }, [_c('p', {
    staticClass: "accordion-title weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('figure', {
    staticClass: "accordion-icon weex-el weex-image",
    attrs: {
      "src": _vm.isFolded ? _vm.foldIcon : _vm.unfoldIcon,
      "data-img-src": _vm.isFolded ? _vm.foldIcon : _vm.unfoldIcon,
      "weex-type": "image"
    }
  })]), _vm._v(" "), (!_vm.isFolded) ? _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("content", null, {})], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-289f9703", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-289f9703","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-accordion/index.vue
// module id = 581
// module chunks = 0 1